var _circle, _circle2, _circle3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallCenterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#1552E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9989,
    cy: 44.9989,
    r: 42.4286,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1547_127533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 80,
    height: 80
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0203,
    cy: 45.0203,
    r: 39.8796,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1547_127533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9375 33.5411C32.9071 32.5516 36.7916 28.3932 39.1394 24.166C42.2186 27.2738 47.361 30.2488 52.1386 30.2488C55.1698 30.2488 58.0149 29.4705 60.4765 28.1085",
    stroke: "#B7CCFF",
    strokeWidth: 1.87509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6719 51.2488C66.6537 50.9378 69.0061 47.3257 69.0061 42.9158C69.0061 38.5052 66.6537 34.8931 63.6719 34.582V51.2488Z",
    fill: "#FF8165"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0031 64.791C46.476 64.791 47.6702 65.9571 47.6702 67.3953C47.6702 68.8333 46.476 69.9994 45.0031 69.9994C43.5302 69.9994 42.3359 68.8333 42.3359 67.3953C42.3359 65.9571 43.5302 64.791 45.0031 64.791Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1381 66.4659C52.522 65.9727 55.9504 64.8169 58.255 62.5625C61.1174 59.7633 63.3478 55.017 63.3478 50.7718V36.3284C63.3478 32.0833 61.1174 27.7792 58.255 24.9804C55.3931 22.1808 50.9915 20 46.6505 20H44.4844C40.1434 20 35.7424 22.1808 32.8804 24.9804C30.018 27.7792 27.9375 30.3383 27.9375 34.5834",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3303 51.0441C24.2327 50.7369 21 47.1696 21 42.8144C21 38.4585 24.2327 34.8912 28.3303 34.584V51.0441Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6719 51.0422C67.7695 50.735 71.0022 47.1677 71.0022 42.8125C71.0022 38.4565 67.7695 34.8892 63.6719 34.582V51.0422Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.539 63.002C47.5148 63.002 49.1169 64.5687 49.1169 66.5011C49.1169 68.4333 47.5148 70 45.539 70C43.563 70 41.9609 68.4333 41.9609 66.5011C41.9609 64.5687 43.563 63.002 45.539 63.002Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4688 34.9725C32.7133 33.9271 37.1226 30.6342 39.6004 26.168C42.85 29.4515 47.4041 31.4941 52.4461 31.4941C55.645 31.4941 58.6476 30.6718 61.2453 29.2328",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenterLogo);
export default __webpack_public_path__ + "static/media/CallCenterLogo.9f85f109a8a2c777e60685b54331d2e6.svg";
export { ForwardRef as ReactComponent };